export const addReasons = (issue_reported, offer_id, property_id, issue_reported_at) => {
  return {
    issue_reported,
    offer_id,
    property_id,
    issue_reported_at
  };
};
